import _ from "lodash";
import { push } from "connected-react-router";

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, showSuccessMessage } from "./ui";
import { getPollInfo, createPoll, editPoll } from "../../request";

//Редактирование формы опроса
export const SET_POLL_NAME = "Set poll name";
export const TOGGLE_CLIENTS_TYPE = "Toggle clients type";
export const TOGGLE_CONSULTANTS_TYPE = "Toggle consultants type";

export const SET_ANSWER_NAME = "Set answer name";
export const ADD_NEW_ANSWER = "Add new answer";
export const DELETE_ANSWER = "Delete answer";

//Очистка формы опроса
export const CLEAR_POLL_FORM = "Clear poll form";

//Создание опроса
export const POLL_CREATION_START = "Poll creation start";
export const POLL_CREATED_SUCCESSFULLY = "Poll created successfully";
export const POLL_CREATION_FAILED = "Failure during poll creation";

//Загрузка информации о редактируемом опросе
export const EDITING_POLL_LOADING_START = "Editing poll form loading start";
export const EDITING_POLL_LOADED_SUCCESSFULLY = "Editing poll form loaded successfully";
export const EDITING_POLL_LOADING_FAILED = "Failure during editing poll form load";

//Редактирование опроса
export const POLL_EDITING_START = "Poll editing start";
export const POLL_EDITED_SUCCESSFULLY = "Poll edited successfully";
export const POLL_EDITING_FAILED = "Failure during poll editig";

//РЕДАКТИРОВАНИЕ ФОРМЫ ОПРОСА

//Название опроса
export const setPollName = value => ({
  type: SET_POLL_NAME,
  payload: { value }
});

//Тип опроса
export const toggleClientsType = () => ({
  type: TOGGLE_CLIENTS_TYPE,
});

export const toggleConsultantsType = () => ({
  type: TOGGLE_CONSULTANTS_TYPE,
});

//Варианты ответов
export const setAnswerName = (value, answerIndex) => ({
  type: SET_ANSWER_NAME,
  payload: { value, answerIndex }
});

export const addNewAnswer = () => ({
  type: ADD_NEW_ANSWER,
});

export const deleteAnswer = answerIndex => ({
  type: DELETE_ANSWER,
  payload: { answerIndex }
});

//Очистка формы опроса
export const clearPollForm = () => ({
  type: CLEAR_POLL_FORM
});

//СОЗДАНИЕ ОПРОСА
const startCreation = () => ({
  type: POLL_CREATION_START
});

const creationSuccess = () => ({
  type: POLL_CREATED_SUCCESSFULLY,
});

const creationFailure = () => ({
  type: POLL_CREATION_FAILED,
});

export const createPollAsync = () => {
  return async (dispatch, getState) => {
    dispatch(startCreation());
    await dispatch(checkAndRenewTokens());
    const currentState = getState();
    const poll = currentState.editPoll.poll;

    //Приведем данные опроса к нужному формату
    if (poll.clients && !poll.consultants) poll.type = 'CLIENTS';
    else if (!poll.clients && poll.consultants) poll.type = 'CONSULTANTS';
    else poll.type = 'ALL';
    const data = _.omit(poll, ['id', 'clients', 'consultants']);

    try {
      const accessToken = localStorage.getItem("accessToken");
      await createPoll(accessToken, data);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при создании опроса'));
      return dispatch(creationFailure());
    }
    dispatch(push('/polls'));
    dispatch(showSuccessMessage('Новый опрос создан'));
    return dispatch(creationSuccess());

  };
};

//ЗАГРУЗКА ИНФОРМАЦИИ О РЕДАКТИРУЕМОМ ОПРОСЕ
const startLoading = () => ({
  type: EDITING_POLL_LOADING_START
});

const loadSuccess = poll => ({
  type: EDITING_POLL_LOADED_SUCCESSFULLY,
  payload: { poll },
}); 

const loadFailure = () => ({ 
  type: EDITING_POLL_LOADING_FAILED,
});

//ЗАГРУЗКА ИНФОРМАЦИИ ОБ ОПРОСЕ
export const getEditingPollAsync = pollId => {
  return async (dispatch) => {
    dispatch(startLoading());
    await dispatch(checkAndRenewTokens());
    let poll; 

    try {
      const accessToken = localStorage.getItem("accessToken");
      poll = await getPollInfo(accessToken, pollId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при загрузке информации об опросе'));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(poll));
  };
};

//РЕДАКТИРОВАНИЕ ОПРОСА
const startEditing = () => ({
  type: POLL_EDITING_START
});

const editingSuccess = () => ({
  type: POLL_EDITED_SUCCESSFULLY,
});

const editingFailure = () => ({
  type: POLL_EDITING_FAILED,
});

export const editPollAsync = pollId => {
  return async (dispatch, getState) => {
    dispatch(startEditing());
    await dispatch(checkAndRenewTokens());
    const currentState = getState();
    let poll = currentState.editPoll.poll;

    //Приведем данные опроса к нужному формату
    if (poll.clients && !poll.consultants) poll.type = 'CLIENTS';
    else if (!poll.clients && poll.consultants) poll.type = 'CONSULTANTS';
    else poll.type = 'ALL';
    const data = _.omit(poll, ['clients', 'consultants']);

    try {
      const accessToken = localStorage.getItem("accessToken");
      await editPoll(accessToken, data, pollId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage('Ошибка при редактировании опроса'));
      return dispatch(editingFailure());
    }
    dispatch(push('/poll/' + pollId));
    dispatch(showSuccessMessage('Опрос отредактирован'));
    return dispatch(editingSuccess());
  };
};